import React from 'react';
const WallContext = React.createContext({});

export default WallContext;
